import { render, staticRenderFns } from "./objectAdd.vue?vue&type=template&id=71c8afa0&scoped=true"
import script from "./objectAdd.vue?vue&type=script&lang=js"
export * from "./objectAdd.vue?vue&type=script&lang=js"
import style0 from "./objectAdd.vue?vue&type=style&index=0&id=71c8afa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8afa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c8afa0')) {
      api.createRecord('71c8afa0', component.options)
    } else {
      api.reload('71c8afa0', component.options)
    }
    module.hot.accept("./objectAdd.vue?vue&type=template&id=71c8afa0&scoped=true", function () {
      api.rerender('71c8afa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectAdd.vue"
export default component.exports